/*
 * @Descripttion: 头部menu
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 17:02:51
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-09-03 10:45:56
 */

const headMenus = {
  index: {
    // name: 'ArteryFlow-The Leader in Intelligent Diagnosis and Treatment of Cardiovascular and Cerebrovascular Diseases',
    name: 'ArteryFlow',
    title: 'Home'
  },
  innovative: {
    name: 'Products & Solutions',
    title: 'Products & Solutions',
    intracranial: 'Cerebrovascular Product Portfolio',
    aneurysm: ['For Aneurysm'],
    AneuFlow: 'AneuFlow | Preoperative Hemodynamic assessment',
    AneuPlan: 'AneuPlan | Preoperative Planning',
    AneuGuide: 'AneuGuide | Intraoperative Interventional Planning',
    AneuShape: 'AneuShape | Intraoperative Microcatheter Shaping',
    stroke: ['For Stroke'],
    AccuASPECTS: 'AccuASPECTS | Automated Calculation of ASPECTS',
    AccuCTP: 'AccuCTP | Cerebral Perfusion Analysis',
    narrow: ['For ICAS'],
    AccuFFicas: 'AccuICAS | ICAS Functional Assessment',
    intracardiac: 'Cardiovascular Product Portfolio',
    accuffr: ['AccuFFR Product Series'],
    AccuFFRct: 'AccuFFRct | CTA-derived Non-invasive FFR',
    AccuFFRangio: 'AccuFFRangio | Angiography-derived FFR',
    AccuFFRivus: 'AccuFFRivus | IVUS-derived FFR',
    AccuFFRoct: 'AccuFFRoct | OCT-derived FFR',
    structureFunction: ['More Products'],
    AccuLV: 'AccuLV | Non-invasive Cardiac Functional assessment',
    AccuIMR: 'AccuIMR | Microcirculation assessment',
    AccuVALVE: ''
  },
  college: {
    name: 'ArteryFlow-College',
    title: 'College'
  },
  about: {
    name: 'ArteryFlow-About Us',
    title: 'About Us',
    outName: 'ArteryFlow-About Us',
    outTitle: 'About Us'
  },
  news: {
    name: 'ArteryFlow-News',
    title: 'News'
  },
  scienceResearch: {
    name: 'ArteryFlow-Cooperation',
    title: 'Cooperation'
  },
  license: {
    name: 'ArteryFlow-Cooperate',
    title: 'Cooperate'
  },
  job: {
    name: '脉流科技-招贤纳士',
    title: '招贤纳士'
  },
  privacyPolicy: {
    name: '脉流科技-隐私政策',
    title: '隐私政策'
  },
  useClause: {
    name: '脉流科技-使用条款',
    title: '使用条款'
  },
  guidance: {
    name: 'ArteryFlow-Contact Us',
    title: 'Contact Us'
  }
}
const footer = {
  cooperation: {
    title: 'Company information',
    // list: [{ title: 'About Us', url: '/en/about' }, { title: 'Cooperation', url: '/en/scienceResearch' }]
    list: [{ title: 'About Us', url: '/en/about' }]
  },
  product: {
    title: 'Core products',
    list: [
      { title: 'Cerebrovascular Product Portfolio', url: '/en/innovative/intracranial' },
      { title: 'Cardiovascular Product Portfolio', url: '/en/innovative/intracardiac' }
    ]
  },
  contactUs: {
    title: 'Contact us',
    list: [{ des: ['459 Qianmo Road, Suite C1-501, Binjiang District, 310051', 'Hangzhou City, Zhejiang Province, China'] }, { title: 'Telephone：', des: ['+86-0571-88106256', '+86-19157686057'] }, { title: 'Mailbox：', des: ['infor@arteryflow.com'] }]
  },
  code: 'Wechat official account',
  bottom: {
    copy: 'Copyright©2017 杭州脉流科技有限公司 All Rights Reserved',
    network: '浙公网安备 33010802009609号',
    ICP: '浙ICP备17059686号-1'
  }
}
export default { headMenus: headMenus, footer: footer }
